import React, { FC, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Label from '../../../../../components/library/inputs/label/Label';
import { RootState } from '../../../../../store';
import { addField } from '../../../../../slices/formadmin';

interface Props {
  id: string;
  hiddenText: boolean | undefined;
  textColor: string | undefined;
  required: boolean | undefined;
  label: string;
  visible: boolean | undefined;
  size: number;
  children: unknown;
}

const FieldWrapper: FC<Props> = ({ id, visible, hiddenText, textColor, required, label, children }: Props) => {
  const selectedFieldId = useSelector((state: RootState) => state.formAdmin.selectedField);
  const fieldRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (selectedFieldId == id) {
      fieldRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [addField]);

  if (visible) {
    return (
      <div className="form-group" style={{ width: '100%', pointerEvents: 'none' }} ref={fieldRef}>
        <Label hidden={hiddenText} textColor={textColor} required={required} label={label} />
        {children}
      </div>
    );
  }
  return null;
};

export default FieldWrapper;
